import { apis, serviceInterface } from "./config";

export const postAudit = params => {
  return serviceInterface.post(apis.AUDIT, { ...params });
};
